// Core
import { useState } from "react";
import { useSelector } from "react-redux";

// Assets
import NotificationIcon from "../../Assets/Svg/Auth/NotificationBell.svg";
import NavbarLogo from "../../Assets/Images/Logo.png";
import Avator from "../../Assets/Images/avator.png";
import Notifications from "../../Components/Notifications";

// Styles
import "./styles.scss";

// Custom component
import FooterColorLine from "../../Components/FooterColorLine";

const Navbar = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const roleMap = {
  1: "Admin",
  2: "Assessor",
  3: "User",
  4: "Approver"
  };

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const role = userDetails?.role;
  const userName = userDetails?.user_name;
  const roleName = roleMap[userDetails?.role];

  const notifications = useSelector(
    (state) => state.notification.notifications
  );
  const hasUnread = notifications?.some((n) => n.is_read === false);
  const isLoading = useSelector((state) => state.notification.isLoading);

  const toggleNotifications = () => {
    setIsNotificationOpen(!isNotificationOpen);
    setIsProfileDropdownOpen(false); // close profile dropdown when notification opens
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdownOpen(!isProfileDropdownOpen);
    setIsNotificationOpen(false); // close notifications when profile opens
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/"; // or your logout logic
  };

  return (
    <>
      <div className="nav-container">
        <div className="navbar">
          <div className="nav-logo">
            <img src={NavbarLogo} alt="logo" className="logo" width="66" />
          </div>
          <div className="nav-items">
            {role === 2 && (
              <div className="notification-wrapper">
                <img
                  src={NotificationIcon}
                  alt="notification"
                  className="notification-icon"
                  onClick={toggleNotifications}
                />
                {hasUnread && <span className="notification-dot"></span>}
              </div>
            )}
            <div className="profile" onClick={toggleProfileDropdown}>
              <img
                className="nav-user-image"
                src={userDetails.profile_image ?? Avator}
                alt="*"
                width="30"
                height="30"
              />
            </div>
          </div>
        </div>
        <FooterColorLine />
      </div>

      {/* Notifications dropdown */}
      {isNotificationOpen && (
        <div className="notifications-wrapper">
          <Notifications
            onClose={() => setIsNotificationOpen(false)}
            notifications={notifications}
            isLoading={isLoading}
          />
        </div>
      )}

      {/* Profile dropdown */}
      {isProfileDropdownOpen && (
        <div className="profile-dropdown-wrapper">
          <div className="profile-dropdown">
            <p className="user-name">{userName}</p>
            <p className="role-name">{roleName}</p>
            <button className="logout-button" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
